import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'; 


import { catchError, retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { User } from '../classes';
import { GlobalService } from '../services/global.service';


@Injectable({
  providedIn: 'root'
})

export class LoginService {
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      console.log("Error status: ",error.status);
      
      if(error.status == 0){
        console.error("IMPOSSIBILE CONNETTERSI AL SERVER");
      }
      else{
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      }
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  };

  
  constructor(private http: HttpClient,
    private globalServices: GlobalService) { }

  doLogin(user: User): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': ''
      })
    };
    console.log("Login URL: ", this.globalServices.loginURL);
    
    return this.http.post<any>(this.globalServices.loginURL, user, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  secondLogin(token, id): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    
    return this.http.get<any>(this.globalServices.secondLoginURL(id), httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  doLogout(token): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    }

    return this.http.get<any>(this.globalServices.logoutURL, httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

}